<template>
    <e-charts
        id="chart"
        ref="line"
        height="800px"
        autoresize
        :options="option"
        theme="theme-color"
        auto-resize
    />
</template>

<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/chart/bar';
import theme from './theme.json';

ECharts.registerTheme('theme-color', theme);

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: this.optionData.grid,
        xAxis: this.optionData.xAxis,
        yAxis: this.optionData.yAxis,
        series: this.optionData.series,
        responsive: [
          {
            breakpoint: 1000,
            options: {
              plotOptions: {
                bar: {
                  horizontal: false,
                },
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        chart: {
          width: 380,
          height: 480,
          type: 'bar',
        },

      },
    };
  },
  watch: {
    optionData: {
      deep: true,
      handler(newVal) {
        this.option = {
          ...this.option,
          grid: newVal.grid,
          xAxis: newVal.xAxis,
          yAxis: newVal.yAxis,
          series: newVal.series,
        };
      },
    },
  },
};
</script>
<style scoped>

#chart {
  width: 100vw;
  max-width: 100%;
  margin: 25px auto;
  opacity: 0.9;
}
</style>
